module.exports = __webpack_public_path__ + "static/trintech-4c8c51c41b948dadd1a2b288f0c1da4e.png";